limitingTrie